import { isTourGuidePath } from './favicon';

// /tourguide is branded TourGuide; every other route keeps YourTour (#2057).
// The TourGuide AI brochure ('tgaib') sets its own title in BrochurePage, so
// it gets none here — otherwise a late community config would overwrite it.

/**
 * Build the document title for a route.
 *
 * @param {string} communityName - Community name from config
 * @param {string} pathname - Router pathname
 * @param {string} featurePlatform - Feature platform from getSettings
 * @returns {string|null} Title, or null when this route's title is owned elsewhere
 */
const getRouteDocumentTitle = (communityName, pathname, featurePlatform) => {
  if (!communityName || featurePlatform === 'tgaib') {
    return null;
  }
  const productName = isTourGuidePath(pathname) ? 'TourGuide' : 'YourTour';
  return `${communityName} | ${productName}`;
};

export default getRouteDocumentTitle;
